import React, { useState, useEffect, useCallback } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Grid,
} from '@mui/material';
import axios from 'axios';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import { LoadingButton } from '@mui/lab';
import Div from '@jumbo/shared/Div';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';

function MenuPermissionsManager() {
  // Mock data for roles and menu labels (replace with actual API data)
  const [roles,setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [menuLabels, setMenuLabels] = useState([]);
  const [menusubmitted, setMenusubmitted] = useState(false);
  const [menuUpdatedPermissions, setMenuUpdatedPermissions] = useState([]);
  const swal = useSwalWrapper();

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
   };
  function buildMenuTree(data, parentCode = 0) {
    const tree = [];  
    data.forEach((item) => {
      if (item.FL_PARENT_MENU_CODE === parentCode) {
        const hasChildren = data.some((childItem) => childItem.FL_PARENT_MENU_CODE === item.FL_MENU_CODE);
  
        const node = {
         ...item,
          children: hasChildren ? buildMenuTree(data, item.FL_MENU_CODE) : undefined, // Recursive call for children
          // Add other properties as needed
        };
  
        tree.push(node);
      }
    });
    return tree;
  }
  const fetchMenuPermissions = async () => {
    try {
      setMenuLabels([])
      const response = await jwtAuthAxios.post('roleMenu/rolemenupermission', { role: selectedRole });
      const fdata = await buildMenuTree(response.data);
      setMenuLabels(fdata);
    } catch (error) {
      console.error(error);
      swal.fire({
        icon: 'error',
        text: 'Something Went Wrong',
      });
    }
  };
  
  useEffect(() => {
    // Fetch initial menu labels and permissions based on the selected role.
    if (selectedRole) {
      fetchMenuPermissions()
    }
  }, [selectedRole]);
  useEffect(() => {
    jwtAuthAxios.get('roleMenu/roles').then(async(response) => {
        setRoles(response.data);
      });
  }, []);

  // Handle checkbox changes for menu permissions
  const handleCheckboxChange = async (menuCode, permissionType) => {  
    // console.log(menuCode, permissionType);  
    const updatedMenuData = await updatePermissions(menuLabels, menuCode, permissionType);  
    // setRowMenudata(updatedMenuData);
    setMenuLabels(await updatedMenuData);
  };
  function flattenMenuData(menuData) {
    const flattenedMenu = [];
  
    function flatten(menu, parentCode) {
      for (const item of menu) {
        const { children, ...rest } = item;
  
        flattenedMenu.push(rest);
  
        if (children && children.length > 0) {
          flatten(children, item.FL_MENU_CODE);
        }
      }
    }
  
    flatten(menuData, 0);
    return flattenedMenu;
  }
  
  // Call the flattenMenuData function to get the desired output
  
  const savePermission=async ()=>{
    try {
      setMenusubmitted(true)
      const flattenedMenuData = await flattenMenuData(menuLabels);
      await jwtAuthAxios.post('roleMenu/updaterolemenupermission',{menuData:flattenedMenuData,roleId:selectedRole}).then(async data=>{
        swal.fire({
          icon: 'success',
          text: data.data.message,
        });
       await fetchMenuPermissions()
      }).catch(()=>{
        swal.fire({
          icon: 'error',
          text: 'Something Went Wrong',
        });
      })
      setMenusubmitted(false)
    } catch (error) {
      setMenusubmitted(false)
      swal.fire({
        icon: 'error',
        text: 'Something Went Wrong',
      });
    }

  }
  
  const updatePermissions = (menuData, menuCode, permissionType) => {
    return menuData.map((menu) => {
      if (menu.FL_MENU_CODE === menuCode) {
        const updatedMenu = { ...menu };
        // Update the permission based on the permission type
        switch (permissionType) {
          case 'FL_INSERT_ALLOWED':
            updatedMenu.FL_INSERT_ALLOWED = updatedMenu.FL_INSERT_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_UPDATE_ALLOWED':
            updatedMenu.FL_UPDATE_ALLOWED = updatedMenu.FL_UPDATE_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_DELETE_ALLOWED':
            updatedMenu.FL_DELETE_ALLOWED = updatedMenu.FL_DELETE_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_VIEW_ALLOWED':
            updatedMenu.FL_VIEW_ALLOWED = updatedMenu.FL_VIEW_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_PRINT_ALLOWED':
            updatedMenu.FL_PRINT_ALLOWED = updatedMenu.FL_PRINT_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_EXPORT_ALLOWED':
            updatedMenu.FL_EXPORT_ALLOWED = updatedMenu.FL_EXPORT_ALLOWED === 1 ? 0 : 1;
            break;
          case 'FL_MENU':
            updatedMenu.FL_MENU = updatedMenu.FL_MENU === 1 ? 0 : 1;
            break;
          // Add cases for other permission types as needed
          default:
            break;
        }
  
        // Recursively update child menu items
        if (updatedMenu.children && updatedMenu.children.length > 0) {
          updatedMenu.children = updateChildMenuPermissions(
            updatedMenu.children,
            permissionType,
            updatedMenu[permissionType]
          );
        }
  
        return updatedMenu;
      } else if (menu.children && menu.children.length > 0) {
        // Recursively update child menu items even if the parent menu is not the one being updated
        const updatedChildren = updatePermissions(menu.children, menuCode, permissionType);
        return { ...menu, children: updatedChildren };
      }
  
      return menu;
    });
  };
  
  
  const updateChildMenuPermissions = (children, permissionType, newValue) => {
    return children.map((child) => {
      const updatedChild = { ...child };
      updatedChild[permissionType] = newValue;
  
      // Recursively update child's children if applicable
      if (updatedChild.children && updatedChild.children.length > 0) {
        updatedChild.children = updateChildMenuPermissions(
          updatedChild.children,
          permissionType,
          newValue
        );
      }
  
      return updatedChild;
    });
  };
  
const TableWork =(datamenu)=>{
    return(<>{datamenu.map((menu,i)=>{
          <TableRow key={menu.FL_MENU_NAME}>
                  <TableCell>{menu.FL_MENU_NAME}</TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_INSERT_ALLOWED == 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_INSERT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_UPDATE_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_UPDATE_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_DELETE_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_DELETE_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_VIEW_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_VIEW_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_PRINT_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_PRINT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_EXPORT_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_EXPORT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_MENU === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_MENU'))}
                    />
                  </TableCell>
                  {/* Repeat the above pattern for other permission types (Update, Delete, View, Print, Export) */}
                </TableRow>
                {menu.children && TableWork(menu.children)}
                }                
                )}
                </>
              )
}
  return (
    <div>
      <Grid container>
      <Grid item xs={6}>
        <h2>Menu Permissions Manager</h2>
      </Grid>
      <Grid item xs={6}>
      <FormControl size='small' sx={{mb:2,display: 'block',marginLeft: 'auto',width: 'fit-content'}}>
        <InputLabel>Select Role</InputLabel>
        <Select size='small' sx={{width:200}} value={selectedRole} onChange={handleRoleChange}>
          {roles.map((role) => (
            <MenuItem key={role.FL_ROLE_ID} value={role.FL_ROLE_ID}>
              {role.FL_ROLE_NAME}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </Grid>
      </Grid>
      {selectedRole && (<>
        <TableContainer component={Paper}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Menu Label</TableCell>
                <TableCell>Insert</TableCell>
                <TableCell>Update</TableCell>
                <TableCell>Delete</TableCell>
                <TableCell>View</TableCell>
                <TableCell>Print</TableCell>
                <TableCell>Export</TableCell>
                <TableCell>Menu</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            <MenuTree menuData={menuLabels} handleCheckboxChange={handleCheckboxChange} />
                {/* {TableWork(menuLabels)} */}
            </TableBody>
          </Table>
        </TableContainer>
      <LoadingButton loading={menusubmitted} variant="contained" sx={{display: 'block',margin: '18px auto'}} onClick={savePermission} color="primary">
        Save Permissions
      </LoadingButton></>
          )}
    </div>
  );
}
const MenuTree = ({ menuData, handleCheckboxChange,loop=1 }) => {
    return (
      <>
        {menuData.map((menu,i) => (
          <React.Fragment key={menu.FL_MENU_CODE+i}>
            <TableRow color="primary">
              <TableCell sx={{pl:loop *2}}>{menu.FL_MENU_NAME}</TableCell>
              <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_INSERT_ALLOWED == 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_INSERT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_UPDATE_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_UPDATE_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_DELETE_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_DELETE_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_VIEW_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_VIEW_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_PRINT_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_PRINT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_EXPORT_ALLOWED === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_EXPORT_ALLOWED'))}
                    />
                  </TableCell>
                  <TableCell sx={{width:'30px'}}>
                    <Checkbox
                      checked={menu.FL_MENU === 1}
                      onChange={()=>(handleCheckboxChange(menu.FL_MENU_CODE, 'FL_MENU'))}
                    />
                  </TableCell>
            </TableRow>
            {menu.children && menu.children.length > 0 && (
                  <MenuTree menuData={menu.children} handleCheckboxChange={handleCheckboxChange} loop={(loop)+1} />
            )}
          </React.Fragment>
        ))}
      </>
    );
  };
  
  MenuPermissionsManager.Modulename = 'MenuPermissions'
export default MenuPermissionsManager;
